import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../constants";
import { ShareContext } from "../context/ShareContext";
import BackLoader from "../components/backloader";
import JisButton from "../components/controls/jisButton";
import CaseSearch from "../components/core/case_search";
import moment from "moment";
import { Padding } from "@mui/icons-material";
import JisTabButton from "../components/controls/jisTabButton";

import wordicon from "../assets/ms_word.png";
import excelicon from "../assets/ms_excel.png";
import pdficon from "../assets/pdf.png";
import CustomSearchSortHeader from "../components/core/CustomSearchSortHeader";
import JisDialog from "../components/dialog";
import JisDialogForm from "../components/formdialog";
import Pagenated from "../components/pagenated";

function CfoSwearing() {
  const { activePage, token, profile, frequentData, setIsExpired, setAlert } =
    useContext(ShareContext);

  const [docs, setDocs] = useState([]);
  const [cases, setCases] = useState([]);
  const [refs, setRefs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [casetype, setCaseType] = useState("litigation");
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState(null);
  const [err, setErr] = useState("");
  const [isSchedule, setIsSchedule] = useState(false);
  const [schedule, setSchedule] = useState({});
  const [tab, setTab] = useState("pending");
  const [count, setCount] = useState(0);

  const navigate = useNavigate();
  useEffect(() => {
    if (pageIndex >= 0) {
      if (search != null) {
        onSearch(search);
      }
    } else {
      setPageIndex(0);
    }
  }, [pageIndex, pageSize, search, tab]);

  const onLoad = async () => {
    //for account registration

    var url = `${Constants.apiUrl}/filing/eswearing-cfo-cases/${pageIndex}/${pageSize}`;

    try {
      setLoading(true);
      const resp = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      if (data.code == 0) {
      }
      setLoading(false);
      console.log(data);
      if (data.code === 0) {
        setCases(data.items);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        alert(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  console.log({ count });

  const onView = (item) => {
    const docId = item.docupload?.[0]?.id;
    if (!docId) {
      setAlert({
        open: true,
        title: "No document",
        subtitle: "There is no uploaded document for this case fee",
      });
      return;
    }
    navigate(`/prepare-document/${docId}/cfo`);
  };

  const onSearch = async (sear) => {
    setSearch(sear);
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/eswearing-cfo-cases/${tab}/${pageIndex}/${pageSize}`,
        {
          method: "POST",
          body: JSON.stringify(sear),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setCases(data.items);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };
  const onSelectSchedule = (doc) => {
    setIsSchedule(true);
    console.log(doc);

    setSchedule({ ...schedule, doc });
  };
  const onSaveSchedule = (e) => {
    e.preventDefault();
    console.log(schedule);
    var sch = {
      docid: schedule.doc.id,
      zoomLink: schedule.zoom,
      scheduledBy: profile.username,
      scheduleDate: schedule.date + " " + schedule.time,
    };

    const uploadurl = `${Constants.apiUrl}/filing/e-swearing/schedule/${schedule.doc.id}`;
    const formData = new FormData();

    // Sending the FormData using fetch
    setLoading(true);
    fetch(uploadurl, {
      method: "POST",
      body: JSON.stringify(sch),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        if (data.code == 0) {
          //saved already
          //first upldate the row and show dialog box
          //setCases(cases.map(i => i.docupload?.[0]?.id === schedule.doc.id ? {...i, zoomLink:sch.zoomLink, schedule:sch.scheduleDate} : i));
          setCases((prevCases) =>
            prevCases.map((i) => {
              if (i.docupload?.[0]?.id === schedule.doc.id) {
                return {
                  ...i,
                  docupload: [
                    {
                      ...i.docupload[0],
                      schedule: sch.scheduleDate,
                      zoomLink: sch.zoomLink,
                    },
                  ],
                };
              }
              return i;
            }),
          );
          setSchedule({});

          setAlert({
            open: true,
            title: "Schedule an Appointment",
            subtitle: "Meeting Schedule is successful",
          });
          setIsSchedule(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false);
      });
  };

  const onPagePick = (pick) => {
    setPageIndex(pick.id - 1);
  };

  const onDirectSearch = (sear) => {
    setSearch(sear);
    setIsSearch(true);
    setPageIndex(0);
  };
  const ReworkStr=(item)=>{
      if(item==null)
      return '';

      if(item.isRework==true){
        return 'Rework Required'
      }
      else if(item.isRework==false){
        return 'Rework Completed'
      }else{
        return 'N/A';
      }
  }
  return (
    <div>
      <div>
        {/* <CaseSearch onSearch={onSearch} frequentData={frequentData} /> */}

        <CustomSearchSortHeader
          onSearch={onDirectSearch}
          frequentData={frequentData}
        />

        <div className="tab_body">
          <div className="exportdiv">
            <img
              src={wordicon}
              // onClick={() => onExport("word")}
              style={{ cursor: "pointer" }}
            />
            <img
              src={excelicon}
              // onClick={() => onExport("excel")}
              style={{ cursor: "pointer" }}
            />
            <img
              src={pdficon}
              // onClick={() => onExport("pdf")}
              style={{ cursor: "pointer" }}
            />
          </div>

          <div className="tab_section cfo-tab-wrapper">
            <JisTabButton
              isActive={tab == "pending"}
              title="Pending Cases"
              isRoleBased={false}
              onClick={() => setTab("pending")}
            />
            <JisTabButton
              isActive={tab == "scheduled"}
              title="Scheduled Cases"
              isRoleBased={false}
              onClick={() => setTab("scheduled")}
            />
            <JisTabButton
              isActive={tab == "completed"}
              title="Commissioned"
              isRoleBased={false}
              onClick={() => setTab("completed")}
            />
          </div>
          <div className="tab_view">
            <div className="table">
              <div class="section-cases">
                <span>E-Swearing Cases</span>
              </div>
              <div className="table-wrapper">
                <table class="case-table">
                  <thead>
                    <tr>
                      {/* <th className="col-id">ID</th> */}

                      <th>Suite Number</th>
                      <th className="col-title">Case Title</th>
                      {tab === "completed" && <th className="col-medium">Date Created</th>}
                      <th>{tab === "completed" ? "Type" : "Status"}</th>
                      <th>
                        {tab === "completed"
                          ? "Commissioned Date"
                          : "Date schedule"}
                      </th>
                      <th>Time</th>
                       {tab == "completed" && <th className="col-title">Virtual</th>}
                      {tab !== "completed" && 
                      <>
                      <th className="col-title">Zoom Link</th>
                      <th className="col-action">Rework</th>
                      </>
                      
                      }
                      {tab === "pending" && <>
                       
                       <th className="col-medium">Schedule</th>
                      {/*  <th className="col-action">Rework</th> */}
                      </>
                     
                      }
                    
                      <th className="col-action">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cases?.map((item, id) => {
                      return (
                        <tr key={id}>
                          {/*  <td>{item.id}</td> */}
                          <td
                            style={{
                              backgroundColor: `${
                                Constants.getItemById(
                                  frequentData?.casecategories,
                                  item.case?.caseCategoryId,
                                )?.colour
                              }`,
                            }}
                          >
                            {" "}
                            {item.case?.caseNumber ?? item.case?.referenceNumber ?? "N/A"}
                          </td>
                          <td>{item.case?.caseTitle || "N/A"}</td>

                          {tab !== "completed" ? (
                            <td>
                              {item.isCompleted
                                ? "Process Completed"
                                : "Pending Upload/Oath"}
                            </td>
                          ) : (
                            <td>
                              {item.docupload?.[0]?.createDate
                                ? moment(item.docupload?.[0]?.createDate).format(
                                    "Do MMMM, YYYY",
                                  )
                                : "N/A"}
                            </td>
                          )}
                          {tab === "completed" ? (
                            <>
                              <td>
                                {Constants.getItemById(
                                  frequentData?.casetype,
                                  item.case?.caseTypeId,
                                )?.caseType1 || "N/A"}
                              </td>
                              <td>
                                {item.docupload?.[0]?.completeDate
                                  ? moment(
                                      item.docupload?.[0]?.completeDate,
                                    ).format("Do MMMM, YYYY")
                                  : "N/A"}
                              </td>
                              <td>
                                {item.docupload?.[0]?.completeDate
                                  ? moment(
                                      item.docupload?.[0]?.completeDate,
                                    ).format("h:mm a")
                                  : "N/A"}
                              </td>
                              <td>
                                {item.isVirtual
                                ? "Zoom Call"
                                : "No Zoom"}
                              </td>
                            </>
                          ) : (
                            <>
                              <td
                                className={
                                  item.docupload?.[0]?.schedule != null
                                    ? "date-time"
                                    : "date-time pends"
                                }
                              >
                                {tab === "pending" && "N/A"}
                                {tab === "scheduled" &&
                                  (item.docupload?.[0]?.schedule != null
                                    ? moment(
                                        item.docupload?.[0]?.schedule,
                                      ).format("Do MMMM, YYYY")
                                    : "N/A")}
                              </td>
                              <td
                                className={
                                  item.docupload?.[0]?.schedule != null
                                    ? "date-time"
                                    : "date-time pends"
                                }
                              >
                                {tab === "pending" && "N/A"}
                                {tab === "scheduled" &&
                                  (item.docupload?.[0]?.schedule != null
                                    ? moment(
                                        item.docupload?.[0]?.schedule,
                                      ).format("h:mm a")
                                    : "N/A")}
                              </td>
                            </>
                          )}
                          {tab !== "completed" && (
                            <><td
                              className={
                                item.docupload?.[0]?.schedule != null
                                  ? "zoom"
                                  : "zoom pends"
                              }
                            >
                              {item.docupload?.[0]?.zoomLink != null ? (
                                <a
                                  href={item.docupload?.[0]?.zoomLink}
                                  target="_blank"
                                  className="cfo-text-link"
                                  rel="noreferrer"
                                >
                                  {" "}
                                  Zoom Link{" "}
                                </a>
                              ) : (
                                "N/A"
                              )}{" "}
                            </td>
                            <td>{ReworkStr(item.docupload?.[0])} </td>
                            </>
                            
                          )}
                          {tab === "pending" && (
                           <>
                          
                           <td className="cfo-swearing-btn-cell">
                              <JisButton
                                variant="plain"
                                onClick={() =>
                                  onSelectSchedule(item.docupload?.[0])
                                }
                              >
                                Schedule
                              </JisButton>
                            </td>
                         {/*  <td>{ReworkStr(item.docupload[0])} </td> */}
                           </>
                           
                          )}
                          <td className="cfo-swearing-btn-cell">
                            {" "}
                            {tab === "completed" ? (
                              <div
                                style={{
                                  minWidth: "180px",
                                }}
                                className="selected"
                                onClick={() => onView(item)}
                              >
                                View Documents
                              </div>
                            ) : (
                              <JisButton
                                variant="plain"
                                className="black"
                                onClick={() => onView(item)}
                              >
                                View Documents Attached
                              </JisButton>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {!loading && cases?.length === 0 && (
                  <p style={{ padding: 16, textAlign: "center" }}>
                    {search?.caseTitle || search?.caseNumber
                      ? "No records found for this search"
                      : "No records found"}
                  </p>
                )}
                {err && <div className="error-message">{err}</div>}
              </div>
              {cases?.length > 0 && (
                <Pagenated
                  onChangePageSize={(k) => setPageSize(k)}
                  size={pageSize}
                  total={count}
                  maxPage={20}
                  onPick={onPagePick}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <BackLoader open={loading} />
      {isSchedule && (
        <JisDialogForm minWidth="40%" title="e-Swearing Appointment">
        <form onSubmit={onSaveSchedule}>
          <div className="">
            <div>
              <div className="input-group">
                <label>Zoom Link</label>

                <div className="input-wrapper">
                  <input
                    placeholder="Zoom Link"
                    required={true}
                    type="url"
                    value={schedule.zoom}
                    onChange={(e) =>
                      setSchedule({ ...schedule, zoom: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="input-group">
                <label>Zoom meeting date</label>
                <div className="input-wrapper">
                  <input
                    placeholder="Schedule Date"
                    type="date"
                    required={true}
                    value={schedule.date}
                    onChange={(e) =>
                      setSchedule({ ...schedule, date: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="input-group">
                <label>Zoom meeting time</label>
                <div className="input-wrapper">
                  <input
                    type="time"
                    placeholder="Zoom meeting time"
                    value={schedule.time}
                    onChange={(e) =>
                      setSchedule({ ...schedule, time: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="schedule_btn_wrapper">
                <button
                  variant={"outline"}
                  onClick={() => setIsSchedule(false)}
                >
                  Cancel
                </button>
                <button type="submit">Schedule Appointment</button>
              </div>
            </div>
          </div>
          </form>
        </JisDialogForm>
      )}
    </div>
  );
}

export default CfoSwearing;
